import { Button } from "@mui/material";
import React from "react";
import QRCodeStyling from "qr-code-styling";
import { IconGoToTab } from "../../../../utils/icons";
import { IBrand } from "../../../brand/team/data/type";
import config from "../../../../config";
import Qr from "../../../../components/Qr/Qr";
import { PanelFooter } from "./PanelFooter";

interface Props {
  brand: IBrand;
  openSettings: () => void;
  s3id?: number | null;
}

export function QrPanel({ brand, s3id, openSettings }: Props) {
  const formatLandingUrl = (source: string = "landing", preview = false) => {
    let previewString = "";
    if (preview) {
      previewString = "&preview=true";
    }
    return `${config.EMBED_HOST}/brands/${brand.id}/${brand.slug}/single/${s3id}?source=${source}${previewString}`;
  };

  const downloadQr = () => {
    const qr = new QRCodeStyling({
      margin: 10,
      dotsOptions: {
        color: "#000",
        type: "square",
      },
      data: formatLandingUrl("qr"),
      width: 1000,
      height: 1000,
    });
    qr.download({ extension: "png" });
  };

  return (
    <div className="flex flex-col gap-2 justify-between h-full">
      <div className="py-6 flex flex-col w-full gap-4 flex-1 min-h-0 overflow-y-auto">
        <div className="p-4 bg-surface-2 rounded-md flex items-center justify-center h-full">
          <Qr qrSize={180} url={formatLandingUrl("qr")} disableDownload />
        </div>
      </div>
      <PanelFooter>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => window.open(formatLandingUrl("landing", true), "_blank")}
          endIcon={<IconGoToTab stroke="#444" />}
          sx={{ textTransform: "capitalize" }}
        >
          Preview QR Link
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={downloadQr}
          sx={{ textTransform: "capitalize" }}
        >
          Download QR Code
        </Button>
      </PanelFooter>
    </div>
  );
}
